import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useTranslation } from "react-i18next";
export var InfoBar = function (_a) {
    var elements = _a.elements;
    var t = useTranslation(['advanced-search']).t;
    return (_jsx(React.Fragment, { children: _jsx("div", { className: "under-filter-info", children: _jsxs("div", { children: [" ", elements, " ", t("éléments")] }) }) }));
};
